function switchMenu(grid, icon, isMobile){

    var isIconActive = $(".info-grid." + grid + " .icon[data-icon='"+icon+"']").hasClass('active');

    // Fix for allowing first mobile icon to be closed
    if(grid === 'bottom' && icon === 1 && isMobile){
        if(isIconActive && !$(".icon-grid-description[data-grid='" + grid + "'] .icon[data-icon='"+icon+"']").hasClass('active')){
            isIconActive = false;
        }
    }

    // Show Desktop Icon Active
    $(".info-grid." + grid + " .icon").removeClass('active');
    $(".icon-grid-description[data-grid='" + grid + "'] .icon").removeClass('active');
    $(".icon-grid-description[data-grid='" + grid + "'] .description").hide();


    // Close the tab if the icon is already open and we are on mobile
    if(!(isIconActive && isMobile)){
        // Show Desktop Icon active
        $(".info-grid." + grid + " .icon[data-icon='"+icon+"']").addClass('active');

        // Show Mobile Icon Active
        $(".icon-grid-description[data-grid='" + grid + "'] .icon[data-icon='"+icon+"']").addClass('active');

        // Show the Icon Description Text
        $(".icon-grid-description[data-grid='" + grid + "'] ." + icon).show();
    }
}

$(".info-grid .icon").on('click', function () {
    var icon = $(this).data("icon");
    var grid = $(this).closest('.info-grid').data('grid');
    switchMenu(grid, icon, false);
});

$(".icon-grid-description .icon").on('click', function () {
    var icon = $(this).data("icon");
    var grid = $(this).closest('.icon-grid-description').data('grid');
    switchMenu(grid, icon, true);
});